// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.d-flex.mt-4 {
  min-height: 6.25rem;
}
div.d-flex.mt-4 > div:first-child {
  width: 3rem;
  height: 3rem;
}
div.d-flex > div:first-child {
  width: 1rem;
  height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loading/loading.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AACQ;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;AAAR","sourcesContent":["div.d-flex {\n    &.mt-4 {\n        min-height: 6.25rem;\n        & > div:first-child {\n        width: 3rem;\n        height: 3rem;\n    }\n    }\n    & > div:first-child {\n        width: 1rem;\n        height: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
